import * as z from 'zod'

export const WhatsappSchema = z.object({
	phone: z.string().nonempty().min(12).max(13),
	message: z.string().default(``).optional(),
	alias: z.string().optional()
})

export type WhatsappType = z.TypeOf<typeof WhatsappSchema>